import React, { useState } from 'react';

const FinalExamModal = ({ open, onClose, questions, onFinish }) => {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(null);

  if (!open) return null;

  const handleAnswer = (questionId, choice) => {
    setAnswers({ ...answers, [questionId]: choice });
  };

  const handleNext = () => {
    if (current < questions.length - 1) {
      setCurrent(current + 1);
    }
  };

  const handleSubmit = () => {
    let correctCount = 0;
    questions.forEach((q) => {
      if (answers[q.id] === q.correct_answer) {
        correctCount++;
      }
    });
    const finalScore = Math.round((correctCount / questions.length) * 100);
    setScore(finalScore);
    setSubmitted(true);
    onFinish(finalScore);
  };

  const q = questions[current];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-lg max-w-xl w-full">
        <h2 className="text-xl font-bold mb-4 text-indigo-700">Final Exam</h2>

        {submitted ? (
          <div>
            <p className="text-lg mb-4">You scored <strong>{score}%</strong>.</p>
            {score >= 90 ? (
              <p className="text-green-600 font-semibold">Congratulations! You've passed the final exam.</p>
            ) : (
              <p className="text-red-600 font-semibold">Score below 90%. Please review and retake the test.</p>
            )}
            <button
              className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        ) : (
          <div>
            <p className="mb-2 font-semibold text-indigo-600">Question {current + 1} of {questions.length}</p>
            <p className="mb-4 font-medium">{q.question}</p>
            <div className="space-y-2">
              {q.choices.map((choice, i) => (
                <label key={i} className="block">
                  <input
                    type="radio"
                    name={`q-${q.id}`}
                    value={choice}
                    checked={answers[q.id] === choice}
                    onChange={() => handleAnswer(q.id, choice)}
                    className="mr-2"
                  />
                  {choice}
                </label>
              ))}
            </div>

            <div className="mt-6 flex justify-between">
              <button
                className="px-4 py-2 bg-gray-200 rounded"
                onClick={onClose}
              >
                Cancel
              </button>
              {current < questions.length - 1 ? (
                <button
                  className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                  onClick={handleNext}
                  disabled={!answers[q.id]}
                >
                  Next
                </button>
              ) : (
                <button
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                  onClick={handleSubmit}
                  disabled={!answers[q.id]}
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FinalExamModal;
